import React, { useState, Fragment, useEffect } from 'react';
import {
    Row, Card, Input, DropdownMenu,
    DropdownItem, UncontrolledDropdown,
    DropdownToggle, Button, ModalHeader,
    Modal, ModalFooter, ModalBody, FormGroup,
    Label,Tooltip
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import TuneIcon from '@material-ui/icons/Tune';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import ReactTable from 'react-table';
import DataTablePagination from '../../../../../../components/DatatablePagination';
import { API_Orders_Voucher, gAPI_Voucher_Payment } from '../../../../../../constants/APIs';
import { AxiosAPI } from '../../../../../../helpers/AxiosAPI';

import { uuid } from 'short-uuid';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import ConfirmModal from '../../vouchers/components/forms/ConfirmModal';
import Validation from '../../../../../../components/Validation';
export default function ShowOrders({ onstartDateChange, handleSearchfilter, LoadData, onEndDateChange, handleSubmit, orderList, handleViewOrderClick }) {
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [searchOrder, setSearchOrder] = useState("");
    const [dropDown, setDropDown] = useState(" All");
    const [startDate, setStartDate] = useState(moment().subtract(0, 'days'));
    const [endDate, setEndDate] = useState(moment());
    const [resendEmail, setResendEmail] = useState(false);
    const [confirmModal, setShowConfirmModal] = useState(false);
    const [voidModal, setVoidModal] = useState(false);
    const [refundModal, setRefundModal] = useState(false);
    const [voucherData, setVoucherData] = useState("");
    const [voucherNumber, setVoucherNumber] = useState("");
    const [reason, setReason] = useState("");
    const [emailData, setEmailData] = useState([]);
    const [tooltip, setToolTip] = useState(false);
    const [settlementData, setSettlementData] = useState({
        date:moment(),
        amount:0
    });
    const [settlementModal, setSettlementodal] = useState(false);
    const dataTableColumns = [
        {
            Header: 'Payment Id',
            accessor: 'paymentid',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset', "width": "100px" }
        },
        {
            Header: 'Voucher',
            accessor: 'name',
            Cell: props => <p style={{ marginLeft: "15%", width: "150px" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Voucher#',
            accessor: 'voucherNumber',
            Cell: props => <p style={{ marginLeft: "15%", width: "120px" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Order#',
            accessor: 'orderNumber',
            Cell: props => <p style={{ marginLeft: "11%", "width": "120px" }}>{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Status',
            accessor: 'status',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset', "width": "100px" }
        },
        {
            Header: 'Retail Price',
            accessor: 'price',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.row._original.currency.toUpperCase()} {props.value} </p>,
            style: { 'whiteSpace': 'unset', "width": "100px" }
        },
        {
            Header: 'Discount',
            accessor: 'discount',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.value}%</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Discounted Price',
            accessor: 'discountedPrice',
            Cell: props => <p style={{ marginLeft: "19%", "width": "120px" }} >{props.row._original.currency.toUpperCase()} {props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Fee',
            accessor: 'processingFee',
            Cell: props => <p style={{ marginLeft: "19%", "width": "150px" }}>$ {(parseFloat(props.row._original.processingFee))}</p>,
            style: { 'whiteSpace': 'unset' }
        }
        , {
            Header: 'Gifted',
            accessor: 'gifted',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.row._original.gifted ? "Yes" : "No"}</p>,
            style: { 'whiteSpace': 'unset', }
        },
        {
            Header: 'Integration Name',
            accessor: 'intregationName',
            Cell: props => <p style={{ marginLeft: "10%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Discount',
            accessor: 'discount',
            Cell: props => <p style={{ marginLeft: "15%" }} >{props.value + ' %'} </p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Status',
            accessor: 'redeem',
            Cell: props => <div style={{ position: 'absolute' }} >
                <div className="redeemtip" style={{  color: `${props.value.trim() === "Void" ||props.value.trim() === "Refund"  ? "red" : "darkgreen"}` }} >{props.value}
                    {(props.value === "Void" || props.value === "Refund") && props.row._original.voidReason !=="" && <span className="redeemtipText">{props.row._original.voidReason}</span>}
                </div>
            </div>,
            style: { 'whiteSpace': 'unset' }
        },

        {
            Header: 'Order Email',
            accessor: 'email',
            Cell: props => <p style={{ marginLeft: "12%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Created Date',
            accessor: 'createdDate',
            Cell: props => <p style={{ marginLeft: "10%" }} >{moment(props.value).format("DD-MM-YYYY hh:mm:ss A")}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: '',
            accessor: 'discountedPrice',
            Cell: props => <Fragment>
                {/* {props.value === "2" ? */}
                <div>
                    <UncontrolledDropdown className="w-15 text-center w-sm-100" style={{ position: 'absolute', right: '-3.5rem' }} >
                        <DropdownToggle caret color="outline-dark" size="xs">
                            more
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem
                                key='1View'
                                onClick={() => handleClick(props.row._original)}
                            >
                                Redeem voucher
                            </DropdownItem>
                            <DropdownItem
                                key='2View'
                                onClick={() => handleVoid(props.row._original)}
                            >
                                Void voucher
                            </DropdownItem>
                            <DropdownItem
                                key='3View'
                                onClick={() => handleRefund(props.row._original)}
                            
                            >
                                Refund voucher
                            </DropdownItem>

                            <DropdownItem
                                key='4View'
                                onClick={() => { showResendEmail(props.row._original) }}
                            >
                                Resend email
                            </DropdownItem>
                            <DropdownItem
                                key='5View'
                                onClick={() => { 
                                    setSettlementData({...settlementData,email:props.row._original.email,
                                        voucherNumber:props.row._original.voucherNumber,saleDate:props.row._original.createdDate,amount:props.value});
                                    setSettlementodal(true); }}
                            >
                                Reconcile Payment
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </div>
                {/* //: null} */}
            </Fragment>,
            style: { 'whiteSpace': 'unset' }
        }
    ];    
    const handleReconcilePyament = (data) => {
        AxiosAPI({
            method: 'post',
            url: `${gAPI_Voucher_Payment}/settlement`,
            data: { 'VoucherNumber': settlementData.voucherNumber, 'Amount': settlementData.amount, 'settlementDate': moment(settlementData.date).format('YYYY-MM-DD HH:mm:ss') }
        })
            .then((res) => {
                
                setSettlementodal(false);
                NotificationManager.success(
                    '',
                    'Payment settlement successfully done.',
                    3000,
                    null,
                    null,
                    'success'
                );
            })
    }
    const handleClick = (data) => {        
        //setSearchVoucher("");
        setShowConfirmModal(true);
        setVoucherData(data);

    };
    const handleVoid = (data) => {
        // setSearchVoucher("");
        setVoidModal(true);
        setVoucherData(data);
        setVoucherNumber(data.voucherNumber);

    };
    const handleRefund = (data) => {
        // setSearchVoucher("");
        setRefundModal(true);
        setVoucherData(data);
        setVoucherNumber(data.voucherNumber);

    };
    const showResendEmail = (data) => {
        setResendEmail(true);
        setVoucherNumber(data.voucherNumber);
        let email = [...emailData];
        if (data.gifted === false) {
            email.push({
                id: uuid(),
                email: data.email,
                disable: true
            });
        }
        setEmailData(email);
    };
    const handleResendEmail = () => {
        AxiosAPI({
            method: 'put',
            url: `${API_Orders_Voucher}/voucher/resend`,
            data: { 'VoucherNumber': voucherNumber, 'Email': emailData.map((f) => f.email) }
        })
            .then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                setEmailData([]);
                setResendEmail(false);
                
                NotificationManager.success(
                    '',
                    'Email sent successfully.',
                    3000,
                    null,
                    null,
                    'success'
                );
                }
            })
    };
    const handleUpdateVouchers = (number, status) => {
        if (number !== undefined || null) {
            let date = moment();
            let redeemdate = date.format('YYYY-MM-DD HH:mm:ss');
            AxiosAPI({
                method: 'PUT',
                url: `${API_Orders_Voucher}/voucher/redeem?id=00000000-0000-0000-0000-000000000000&voucherNumber=${number}&status=${status}&redeemDate=${redeemdate}`,
            })
                .then(res => {
                    if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                        && res.data.Messages !== null && res.data.Messages.length > 0) {
                        setMsg(res.data.Messages);
                        setOpen(true);
                    }
                    else {
                    if (res.data.redeem) {
                        LoadData(startDate, endDate);
                    }
                }
                })
                .catch(err => null);
        }
    };
    const deleteEmail = (id) => {
        let email = emailData.filter((f) => f.id !== id);
        setEmailData(email);
    };
    const addEmailData = () => {
        let data = [...emailData];
        data.push({
            id: uuid(),
            email: '',
            disable: false
        });
        setEmailData(data);
    }
    const handleChange = (index, e) => {
        e.persist();
        const newItems = [...emailData];
        newItems[index]['email'] = e.target.value;
        setVoucherData(newItems);
    };
    const handleSearchfilterDate = date => {
        setStartDate(date);
        onstartDateChange(date);
    };
    const handleSearchfilterEndDate = date => {
        setEndDate(date);
        onEndDateChange(date);
    };
    const orderVoucher = () => {
        AxiosAPI({
            method: 'put',
            url: `${API_Orders_Voucher}/voucher/void`,
            data: { 'VoucherNumber': voucherNumber, 'Reason': reason }
        })
            .then(res => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                setReason('');
                setVoidModal(false);
                LoadData(startDate, endDate);
                }
            })
            .catch(err => null);

    };
    const orderRefund= () => {
        AxiosAPI({
            method: 'put',
            url: `${API_Orders_Voucher}/voucher/refund`,
            data: { 'VoucherNumber': voucherNumber, 'Reason': reason }
        })
            .then(res => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                setReason('');
                setRefundModal(false);
                LoadData(startDate, endDate);
                }
            })
            .catch(err => null);

    };
    return (
        <Fragment>
            {/* 
            <Row className="col-md-12">
                <Colxx xxs="2" md="2" className="mb-2">
                    <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                        <DropdownToggle caret color="outline-dark" size="xs" >
                            Status
                            {dropDown}
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem
                                key="2"
                                value="All"
                                onClick={(e) => {
                                    setDropDown(" All");
                                    handleSearchfilter(searchOrder, e.target.value);
                                }}
                            >        All
                            </DropdownItem>
                            <DropdownItem
                                key="1"
                                value="Success"
                                onClick={(e) => {
                                    setDropDown(" Success");
                                    handleSearchfilter(searchOrder, e.target.value);
                                }}
                            >        Success
                            </DropdownItem>
                            <DropdownItem
                                key="0"
                                value="Failed"
                                onClick={(e) => {
                                    setDropDown(" Failed");
                                    handleSearchfilter(searchOrder, e.target.value);
                                }}
                            >        Failed
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </Colxx>
            </Row> */}
            <Row className="col-md-12">
                <Colxx xxs="2" md="2" className="mb-2">
                    <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                        <Input value={searchOrder} className="form-control" placeholder="Search" onChange={(e) => {
                            setSearchOrder(e.target.value);
                            handleSearchfilter(e.target.value, dropDown);
                        }}></Input>     </div>
                </Colxx>

            </Row>
            <Row className="col-md-12">
                {(
                    <Fragment>
                        <Colxx xxs="12" md="2" className="mb-2">
                            <FormGroup><Label>Start Date</Label>
                                <DatePicker
                                    selected={startDate}
                                    onChange={handleSearchfilterDate}
                                    placeholderText="Start Date"
                                    dateFormat="DD/MM/YYYY"
                                />

                            </FormGroup>
                        </Colxx>
                        <Colxx xxs="12" md="2" className="mb-2">
                        <FormGroup><Label>End Date</Label>
                            <DatePicker
                                selected={endDate}
                                onChange={handleSearchfilterEndDate}
                                placeholderText="End Date"
                                dateFormat="DD/MM/YYYY"
                            />
                              </FormGroup>
                        </Colxx>
                        <Colxx xxs="12" md="1" className="mb-2">
                            <Button
                                color="primary"
                                className="mb-2"
                                onClick={() => { handleSubmit(); }}
                            >
                                <IntlMessages id="forms.submit" />
                            </Button>
                        </Colxx>
                    </Fragment>
                )
                }

            </Row >
            <Row className="col-md-12">
                <Colxx xxs="12">
                    <Card className="d
                    -flex flex-row mb-3">
                        <Fragment>
                            <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                                {orderList ? (
                                    <ReactTable
                                        data={orderList}
                                        columns={dataTableColumns}
                                        defaultPageSize={10}
                                        filterable={false}
                                        showPageJump={true}
                                        PaginationComponent={DataTablePagination}
                                        showPageSizeOptions={true}
                                        className="-striped -highlight -bordered"

                                        style={{ width: "100%" }}
                                    />
                                ) : ""
                                }
                            </div>
                        </Fragment>
                    </Card>
                </Colxx>
            </Row>
            <Modal
                isOpen={resendEmail}
                toggle={() => { setEmailData([]); setResendEmail(false) }}
                size="lg"
                style={{ maxWidth: '50%' }}
            >
                <ModalHeader toggle={() => { setEmailData([]); setResendEmail(false) }}><h3>Resend Email</h3></ModalHeader>
                <ModalBody>
                    <div className="">
                        <Row className="mb-2">
                            <Colxx sm={12}>
                                <h4>Email</h4>
                            </Colxx>
                            <Colxx sm={12}>
                                {emailData.map((m, index) => (
                                    <Row key={`${m}~${index}`}>
                                        <Colxx sm={8} className="md-3">
                                            <FormGroup>
                                                <Input type="text" disabled={m.disable} value={m.email} onChange={(e) => {
                                                    handleChange(index, e);
                                                }} />
                                            </FormGroup>

                                        </Colxx>
                                        <Colxx sm={1} className="mb-3">
                                            <div>
                                                <Button
                                                    onClick={() => deleteEmail(m.id)}
                                                    color="secondary"
                                                    size="xs"
                                                    outline
                                                    style={{ margin: '6px' }}
                                                >
                                                    X
                                                </Button>
                                            </div>
                                        </Colxx>
                                    </Row>
                                ))}
                            </Colxx>
                            <Colxx sm={12} className="md-3">
                                <Button
                                    onClick={addEmailData}
                                    color="primary"
                                    size="xs"
                                    outline
                                    style={{ margin: '6px' }}
                                >
                                    + Add email
                                </Button>
                            </Colxx>
                        </Row>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={() => { setEmailData([]); setResendEmail(false) }}>
                        Cancel
                    </Button>
                    <Button color="primary" onClick={() => { handleResendEmail(); }}>
                        Send
                    </Button>
                </ModalFooter>
            </Modal>
            {confirmModal && <ConfirmModal
                showModal={confirmModal}
                message={"Are you sure you want to redeem the voucher ?"}
                title={"Redeem Confirmation"}
                buttonName={"Redeem"}
                hideModal={() => {
                    setShowConfirmModal(false);
                }}
                voucherdata={voucherData}
                redeemStatus={0}
                handleRedeemVoucher={handleUpdateVouchers}
            />}

            <Modal
                isOpen={voidModal}
                toggle={() => setVoidModal(false)}
                size="lg"
                style={{ maxWidth: '30%' }}
            >
                <ModalHeader toggle={() => setVoidModal(false)}><h3>Voucher</h3></ModalHeader>
                <ModalBody><div className="">
                    <Label>Reason</Label>
                    <Input type="text" value={reason} onChange={(e) => setReason(e.target.value)}>
                    </Input>
                </div></ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => { orderVoucher(); }}>
                        Send
                    </Button>
                    <Button onClick={() => setVoidModal(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal
                isOpen={refundModal}
                toggle={() => setRefundModal(false)}
                size="lg"
                style={{ maxWidth: '30%' }}
            >
                <ModalHeader toggle={() => setRefundModal(false)}><h3>Refund Voucher</h3></ModalHeader>
                <ModalBody><div className="">
                    <Label>Reason</Label>
                    <Input type="text" value={reason} onChange={(e) => setReason(e.target.value)}>
                    </Input>
                </div></ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => { orderRefund(); }}>
                        Send
                    </Button>
                    <Button onClick={() => setRefundModal(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>

            {/* Reconcile Payment Modal */}
            <Modal
                isOpen={settlementModal}
                toggle={() => setSettlementodal(false)}
                size="lg"
                style={{ maxWidth: '40%' }}
            >
                <ModalHeader toggle={() => setSettlementodal(false)}><div><h3>Reconcile Payment</h3>
                    <p>Keep your records up to date. Mark the date you received the vouchers payment from <b>aiva</b>.
                    </p>
                    </div>
                </ModalHeader>
                <ModalBody><div className="">                       
                       <div className='d-flex my-2 mb-3'>
                          <span> <b>Voucher Number : {settlementData.voucherNumber !==undefined?settlementData.voucherNumber :""}</b></span>
                          <span className='ml-2'><b> Customer : {settlementData.email !==undefined ?settlementData.email:""}</b></span>
                          <span className='ml-2'><b> Sale Date : {settlementData.saleDate !==undefined ?moment(settlementData.saleDate).format('YYYY-MM-DD HH:mm:ss'):""}</b></span>
                          


                       </div>
                    <FormGroup>
                        <Label><b>Payment Date</b></Label>
                        <DatePicker
                                selected={settlementData.date}
                                onChange={(e)=>setSettlementData({...settlementData,date:e})}
                                placeholderText="Start Date"
                                dateFormat="DD/MM/YYYY"
                            />                        
                    </FormGroup>
                    <FormGroup>
                        <Label><b>Payment Amount</b></Label>
                        <Input type="text" value={settlementData.amount} onChange={()=>null} disabled={true}>
                        </Input>
                    </FormGroup>
                </div></ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => { handleReconcilePyament(); }}>
                        Save
                    </Button>
                    <Button onClick={() => setSettlementodal(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Validation open={open} messages={msg} toggle={()=>{setOpen(!open)}}></Validation>
        </Fragment >
    );
}

